import React, { useState } from 'react';

interface CodeBlockProps {
  code: string;
  language?: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({ code, language = 'javascript' }) => {
  return (
    <div className="my-2 overflow-auto rounded-md bg-gray-950 p-4">
      <pre className="text-sm text-white">
        <code>{code}</code>
      </pre>
    </div>
  );
};

interface Tab {
  language: string;
  code: string;
  title: string;
}

interface TabCodeExamplesProps {
  title?: string;
  description?: string;
  tabs: Tab[];
}

const TabCodeExamples: React.FC<TabCodeExamplesProps> = ({ 
  title, 
  description, 
  tabs 
}) => {
  const [activeTab, setActiveTab] = useState<number>(0);

  return (
    <div className="my-6 rounded-lg border border-gray-200 border-opacity-30 bg-gray-800 bg-opacity-5 p-4">
      {title && <h3 className="mb-2 text-lg font-semibold text-primary">{title}</h3>}
      {description && <p className="mb-4 text-sm text-secondary-300">{description}</p>}
      
      <div className="mb-4 flex flex-wrap gap-2">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
              activeTab === index
                ? 'bg-primary text-white'
                : 'bg-secondary bg-opacity-20 text-gray-300 hover:bg-opacity-30'
            }`}
          >
            {tab.title}
          </button>
        ))}
      </div>
      
      <CodeBlock 
        code={tabs[activeTab].code}
        language={tabs[activeTab].language}
      />
    </div>
  );
};

export default TabCodeExamples; 